import { Controller } from "@hotwired/stimulus"

// The wizard's schedule step. Its editors' fields are the step form's own, so
// its Next button (in the action bar) submits them as they are.
//
// With a Meet & Greet first, the later booking's dates sit in a fieldset
// behind a switch. Switched off, the fieldset is disabled: its dates aren't
// sent, but they stay in the page.
export default class extends Controller {
  static targets = ["laterBooking"]

  toggleLaterBooking({ target: { checked } }) {
    this.laterBookingTarget.hidden = !checked
    this.laterBookingTarget.disabled = !checked
  }
}
